import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import type { AgFrameworkComponent } from 'ag-grid-angular';
import type { IFloatingFilter } from 'ag-grid-community';
import * as _ from 'lodash';

@Component({
    standalone: true,
    imports: [FormsModule],
    template: `
    <div style="position: relative; display: flex; justify-content: start; align-items: center; height: 100%; width: 100%;">
        <input style="flex: 1 1 auto; width: 20px; background: #181E24; padding: 2px 3px; padding-right: 18px;"
        class="focus:outline-none"
        data-show-value="true"
        data-popup-enabled="true"
        [(ngModel)]="currentText"
        (ngModelChange)="textChanged()"
        />
        <button style="position: absolute; top: 5px; right: 0; padding: 1px 4px; cursor: pointer; border-radius: 4px"
        class="hover:bg-[#4B5563]/40 ml-[1px] text-[#d1d1d1]"
        (click)="onClearFilter()">
          <i class="fa-solid fa-xmark"></i>
        </button>
    </div>`,
    styles: [
        `
        :host {
            width: 100%;
        }
        `
    ]
})
export class SetFloatingFilter implements IFloatingFilter, AgFrameworkComponent<any> {
    private params!: any;

    public currentText!: string | null;

    agInit(params: any): void {
      this.params = params;
      this.currentText = null;
    }

    textChanged() {
      // console.log('textChanged', this.currentText);
      const valueToUse = this.currentText;
      if (!valueToUse) {
        this.onClearFilter();
        return;
      }

      let values: any[] = [];
      let colId = this.params.column.colId;
      // console.log(colId, this.params);
      _.each(this.params.context.data, (row: any) => {
        let value = _.get(row, colId, undefined);
        if (value === undefined) return;

        if (typeof value === 'string') {
          let _value = value.toLowerCase();
          if (_value.indexOf(valueToUse.toLowerCase()) >= 0) {
            values.push(value);
          }
        }
      });
      // console.log('values', values);

      this.params.parentFilterInstance((instance: any) => {
        // console.log('parentFilterInstance', instance);
        instance.setModel({
          type: 'set',
          values: values
        });
        this.params.api.onFilterChanged();
      });
    }

    onClearFilter() {
      this.currentText = null;
      this.params.parentFilterInstance((instance: any) => {
        instance.setModel(null);
        this.params.api.onFilterChanged();
      });
    }

    onParentModelChanged(parentModel: any): void {
      //Nothing to do here for the set filter
    }
}